import * as actionTypes from '../actions/actionTypes';
import {updatedObject} from '../../shared/utility';

const initialState = {
    orders: [],
    loading: false,
    purchased: false
}

const purchaseInit = (state, action) => {
    return  updatedObject(state, {purchased:false});
};

const purchaseBurgerStart = (state, action) => {
    return  updatedObject(state, {loading:true});
};

const purchaseBurgerSuccess = (state, action) => {
    const newOrder =  updatedObject(action.OrderData, {id: action.orderId});
    return  updatedObject(state, {
       ...state,
       loading: false,
       purchased: true,
       orders: state.orders.concat(newOrder)
       }); 
};
const purchaseBurgerFailed = (state, action) => {
    return  updatedObject(state, { loading: false });
};

const fetchOrdersStart = (state, action) => {
    return  updatedObject(state, { loading: true });
};
const fetchOrdersSuccess = (state, action) => {
    return updatedObject(state, {
        orders: action.orders,
         loading: false }); 
};
const fetchOrdersFail = (state, action) => {
    return{
        ...state,
        loading: false
     };
};

 const reducer = (state = initialState, action) => {
     switch(action.type) {
         case actionTypes.PURCHASE_INIT: return purchaseInit(state, action);
         case actionTypes.BURGER_PURCHASE_START: return purchaseBurgerStart(state, action);            
         case actionTypes.BURGER_PURCHASE_SUCCESS: return purchaseBurgerSuccess(state, action);  
         case actionTypes.BURGER_PURCHASE_FAILED: return purchaseBurgerFailed(state, action);            
         case actionTypes.FETCH_ORDERS_START: return fetchOrdersStart(state, action);            
         case actionTypes.FETCH_ORDERS_SUCCESS: return fetchOrdersSuccess(state, action);
         case actionTypes.FETCH_ORDERS_FAIL: return fetchOrdersFail(state, action);        
          default:
              return state;       
     }

 };

 export default reducer;